import { Functionaries } from "../../../listsSettings/functionaries";

export const newForm: string = `/${Functionaries.InternalName}/_lists/${Functionaries.Lists.ChapterElections.InternalName}/_pages/new`;
